/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Enum_Initiative_Proactivity21Inputs */

const en_job_form_enum_initiative_proactivity21 = /** @type {(inputs: Job_Form_Enum_Initiative_Proactivity21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Initiative and Proactivity`)
};

const de_job_form_enum_initiative_proactivity21 = /** @type {(inputs: Job_Form_Enum_Initiative_Proactivity21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Initiative und Proaktivität`)
};

/**
* | output |
* | --- |
* | "Initiative and Proactivity" |
*
* @param {Job_Form_Enum_Initiative_Proactivity21Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const job_form_enum_initiative_proactivity21 = /** @type {((inputs?: Job_Form_Enum_Initiative_Proactivity21Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Enum_Initiative_Proactivity21Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_enum_initiative_proactivity21(inputs)
	return en_job_form_enum_initiative_proactivity21(inputs)
});
export { job_form_enum_initiative_proactivity21 as "job_form_enum_INITIATIVE_PROACTIVITY" }